import React, { Component, createRef } from 'react'
import { Container } from 'reactstrap'
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';
import { Col } from 'reactstrap';
import SvgArrow from '../shared/SvgArrow';
import SvgPlus from '../shared/SvgPlus';
import { getItems, checkoutPageEnabled, onlyGiftCards } from '../../store/reducers/shoppingCart';
import CartItem from './CartItem'
import * as actions from "../../store/actions";
import { withTranslation } from 'react-i18next';
import ShoppingCartTotals from './ShoppingCartTotals';

class ShoppingCart extends Component {

    elementRef = createRef();
    placeholderRef = createRef();
    state = {
        ctaFixed: false
    };

    checkLoggedIn = e => {
        if (!this.props.token) {
            e.preventDefault();
            this.props.OnAuthModalToggle();
            // Trigger loggin modal
        }
    };

    componentDidMount() {
     document.querySelector('.content').addEventListener('scroll', this.handleScroll);
     this.checkIfInViewport();

     document.querySelector('body').removeEventListener('click', this.handleOutsideClick);
     document.querySelector('body').addEventListener('click', this.handleOutsideClick);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.items.length != this.props.items.length){
            this.checkIfInViewport(true);
        }
    }

    componentWillUnmount() {
        document.querySelector('.content').removeEventListener('scroll', this.handleScroll);
        document.querySelector('body').removeEventListener('click', this.handleOutsideClick);

    }

    handleScroll = () => {
        this.checkIfInViewport();
    };

    showConfigurationModalHandler = (key, variants, itemIndex) => {
        const { showConfigurationModal } = this.props
        // For cart items, we'll use the cart item data directly
        const currentItem = this.props.items[itemIndex];
        
        document.querySelector('body').removeEventListener('click', this.handleOutsideClick);
        document.querySelector('body').addEventListener('click', this.handleOutsideClick);
        showConfigurationModal(currentItem, variants, itemIndex)
    }

    handleOutsideClick = (e) => {
        if(!e.target.closest('.modal') && !e.target.closest('.cart-config.temp') && document.querySelector('.cart-config.temp .close-overlay')){
            document.querySelector('.cart-config.temp .close-overlay').click()
        }
    }
    

    checkIfInViewport = (force) => {

        if (this.placeholderRef.current) {

            const rect = this.placeholderRef.current.getBoundingClientRect();
            const isInViewport =
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            this.setState({ ctaFixed: !isInViewport });
        }
    };

    render() {
        const { items, checkoutPageButtonEnabled, onlyGiftCards, t } = this.props;

        if (items.length === 0) {
            return <Redirect to="/products" />
        }
        return (
            <div style={{ backgroundColor: "#ECECEA", minHeight: "none", height: "100%" }}>
                <Container className="container-shopping-cart">
                    <Row>
                    <h1 class="h1 w-100 mt-3 text-center text-lg-left">{t('header.cart.laundryBasket')}</h1>
                    </Row>
                </Container>
                <Container className="container-shopping-cart">
                    <Row>
                        <Col lg={8} xl={9} md={12}  style={{ paddingRight: '20px' }}>
                            {
                            items.map((_product, index) => <CartItem key={index} itemIndex={index} summary={true} showConfigurationModalHandler={this.showConfigurationModalHandler} />)
                            }
                        </Col>
                        <Col lg={4} xl={3} md={12}>
                            <div className="container-shopping-cart-totals">
                                <ShoppingCartTotals />
                                <Link to={this.props.i18n.language === 'en' ? '/en/shopping-cart/page2' : '/shopping-cart/page2'} ref={this.elementRef} className={`sticky-a ${this.state.ctaFixed ? '' : ''}`} onClick={this.checkLoggedIn}>
                                    <button className="bold"
                                        disabled={!checkoutPageButtonEnabled}>
                                        {onlyGiftCards ? t('cart.proceedToPayment') : t('cart.proceedToDelivery')}
                                        <SvgArrow />
                                    </button>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                   
                    <Row>
                        <div className="button-placeholder" ref={this.placeholderRef}></div>
                        <Link to={this.props.i18n.language === 'en' ? '/en/products' : '/products'} className={`left sticky-a ${this.state.ctaFixed ? 'fixed' : ''}`}>
                            <button className="bold">
                                <SvgPlus />
                                {t('cart.addMoreItems')}
                            </button>
                        </Link>
                        <Link to={this.props.i18n.language === 'en' ? '/en/shopping-cart/page2' : '/shopping-cart/page2'} ref={this.elementRef} className={`d-lg-none sticky-a ${this.state.ctaFixed ? 'fixed' : ''}`} onClick={this.checkLoggedIn}>
                            <button className="bold"
                                disabled={!checkoutPageButtonEnabled}>
                                {onlyGiftCards ? t('cart.proceedToPayment') : t('cart.proceedToDelivery')}
                                <SvgArrow />
                            </button>
                        </Link>
                      
                    </Row>

                    {this.props.newItemAddedOverlay &&
                    <CartItem 
                        key="temp" 
                        itemIndex={this.props.newItemEditIndex}
                        temp={true}
                        edit={true}
                        showConfigurationModalHandler={this.showConfigurationModalHandler}
                    />
                    }
                    
                </Container>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        items: getItems(state),
        token: state.auth.token,
        checkoutPageButtonEnabled: checkoutPageEnabled(state),
        onlyGiftCards: onlyGiftCards(state),
        newItemOverlayProduct: state.shoppingCart.newItemOverlayProduct,
        newItemAddedOverlay: state.shoppingCart.newItemAddedOverlay,
        newItemAddedOverlayProduct: state.shoppingCart.newItemAddedOverlayProduct,
        newItemEditIndex: state.shoppingCart.newItemEditIndex,
    };
};

const mapDispatchToProps = dispatch => ({
    OnAuthModalToggle: () => dispatch(actions.authModalToggle()),
    showConfigurationModal: (product, variants, itemIndex) => dispatch(actions.showConfigurationModal(product, variants, itemIndex)),
});


export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ShoppingCart));